import axios from "@/store/axiosInstance";
import delay from "@/utilities/delay";

let claimId = null;

const firstForm = {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
        async SEND_FORM(context, data) {
            try {
                let files = data.files;
                let diagramFile = files.diagram[0];
                let sketchFile = files.sketch[0];
                let invoiceFile = files.invoice[0];
                let electriciansLicenceFile = files.electriciansLicence[0];

                let dataToSend = JSON.parse(JSON.stringify(data));
                delete dataToSend.files;

                let query = await axios.post("/claims", dataToSend);
                claimId = query.data.data._id;
                if (query.data.status == "error") {
                    throw new Error(error);
                }

                let fileQuery1 = await context.dispatch("SEND_FILE", {
                    file: diagramFile,
                    type: "diagram",
                });

                let fileQuery2 = await context.dispatch("SEND_FILE", {
                    file: sketchFile,
                    type: "sketch",
                });

                let fileQuery3 = await context.dispatch("SEND_FILE", {
                    file: invoiceFile,
                    type: "invoice",
                });

                let fileQuery4 = await context.dispatch("SEND_FILE", {
                    file: electriciansLicenceFile,
                    type: "electriciansLicence",
                });

                let completeQuery = await context.dispatch("SEND_MAIL");

                return completeQuery;
            } catch (error) {
                throw new Error(error);
            }
        },

        async SEND_FILE(context, data) {
            try {
                let type = data.type;
                let fileData = new FormData();
                fileData.append("file", data.file);

                let fileQuery = await axios({
                    method: "post",
                    url: `/claims/${claimId}/files/${type}`,
                    data: fileData,
                    headers: {
                        "content-type": `multipart/form-data; boundary=${fileData._boundary}`,
                    },
                });
                if (fileQuery.data.status == "error") {
                    throw new Error(error);
                }
                return fileQuery;
            } catch (error) {
                throw new Error(error);
            }
        },

        async SEND_MAIL() {
            try {
                let completeQuery = await axios.post(
                    `/claims/${claimId}/upload-complete`
                );
                return completeQuery;
            } catch (error) {
                throw new Error(error);
            }
        },
    },
};

export default firstForm;
